import { CommonModule, DatePipe } from '@angular/common';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { SharedModule } from '../freightconfirmation/app.sharemodule';
import { TranslateConfigService } from '../theme/home/translateConfig.service';
import { LayoutModule } from '../theme/layouts/layout.module';
import { appService } from '../_services/app.service';
import { CommonService } from '../_services/common.service';
import { BookDashNewComponent } from './book-dash-new.component';

export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, "./assets/translator/", ".txt");
}

const routes: Routes = [
    {
        path: '',
        component: BookDashNewComponent,
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes),
        CommonModule,
        LayoutModule,
        FormsModule,
        SharedModule,
        HttpClientModule,
        ReactiveFormsModule,
    TranslateModule.forRoot({
        loader: {
            provide: TranslateLoader,
            useFactory: createTranslateLoader,
            deps: [HttpClient],
        },
    }),],
    exports: [RouterModule],
    declarations: [BookDashNewComponent],
    providers: [appService, CommonService, DatePipe, TranslateConfigService],
})
export class BookDashNewPageRoutingModule { }
